export function x(d) {
  return d[0];
}

export function y(d) {
  return d[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/point.js
// module id = 1245
// module chunks = 0